import React from "react";

function sxDefinesFontSize(sx) {
  if (Array.isArray(sx)) {
    return sx.some((entry) => entry && typeof entry === "object" && entry.fontSize != null);
  }

  return Boolean(sx && typeof sx === "object" && sx.fontSize != null);
}

function AppCardHeader({
  title = null,
  subtitle = null,
  visual = null,
  action = null,
  titleVariant = "default",
  className = "",
  children,
  ...rest
}) {
  if (!children && !title && !subtitle && !visual && !action) {
    return null;
  }

  const classes = [
    "ds-card__header",
    titleVariant === "compact" ? "ds-card__header--compact" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const visualSize = titleVariant === "compact" ? 18 : 20;

  const resolvedVisual =
    React.isValidElement(visual) && visual.props?.fontSize == null && !sxDefinesFontSize(visual.props?.sx)
      ? React.cloneElement(visual, {
          sx: Array.isArray(visual.props.sx)
            ? [{ fontSize: visualSize }, ...visual.props.sx]
            : [{ fontSize: visualSize }, visual.props.sx].filter(Boolean),
        })
      : visual;

  const actionZone = action ? (
    <div className="ds-card__actions">
      {action}
    </div>
  ) : null;

  if (children) {
    return (
      <header className={classes} {...rest}>
        {children}
      </header>
    );
  }

  return (
    <header className={classes} {...rest}>
      <div className="ds-card__header-main">
        {resolvedVisual || title ? (
          <div className="ds-card__title-row">
            {resolvedVisual ? (
              <div className="ds-card__visual" aria-hidden="true">
                {resolvedVisual}
              </div>
            ) : null}
            {title ? <h3 className="ds-card__title">{title}</h3> : null}
          </div>
        ) : null}
        {subtitle ? <p className="ds-card__subtitle">{subtitle}</p> : null}
      </div>
      {actionZone}
    </header>
  );
}

AppCardHeader.appCardZone = "header";

export default AppCardHeader;
